import { BaseHit, Hit } from 'instantsearch.js';
import { FC } from 'react';
import { useHits, Highlight } from 'react-instantsearch';
import type { SendEventForHits } from 'instantsearch.js/es/lib/utils';
import { DangerousHTML } from '../../../shared/components/DangerousHTML';
import { LoadGuard } from './LoadGuard';
import { AlgoliaUtil } from '../../../shared/utils';
import { AlgoliaArticleHit, NormalizedArticleHit } from '../../../shared/types';

type ArticleHit = Hit<{ title: string; handle: string }>;

const ArticleHit: FC<{
  hit: NormalizedArticleHit;
  insightsHit: Hit<AlgoliaArticleHit>;
  sendEvent: SendEventForHits;
}> = ({ hit, insightsHit, sendEvent }) => {
  const onArticleLinkClick = () => {
    hit.onClickArticleLink({ insightsHit, sendEvent });
  };

  return (
    <a href={hit.url} aria-label={hit.title} onClick={onArticleLinkClick}>
      <div className="aa-article">
        <Highlight
          hit={hit as unknown as Hit<BaseHit>}
          attribute="title"
          highlightedTagName="span"
          classNames={{ highlighted: 'aa-highlight' }}
        />
      </div>
    </a>
  );
};

type ArticleResultsProps = {
  algoliaUtil: AlgoliaUtil;
};

export const ArticleResults = ({ algoliaUtil }: ArticleResultsProps) => {
  const { hits, sendEvent } = useHits<AlgoliaArticleHit>();

  return (
    <LoadGuard noResultsMessage={<DangerousHTML content={theme.locales.autocomplete.notFound.articles} />}>
      {hits.map((hit) => (
        <ArticleHit
          key={hit.objectID}
          hit={algoliaUtil.normalizeArticleHit(hit)}
          insightsHit={hit as Hit<AlgoliaArticleHit>}
          sendEvent={sendEvent}
        />
      ))}
    </LoadGuard>
  );
};
